<MachineHistorySearch headerTextOther="Other Machines History" detailsType="Other Equipment">
